import { RightBarCell } from 'Core/Controls/PlannerLevel/RightBarCell/RightBarCell';
import * as ko from 'knockout';
import * as _ from "underscore";

import {RenderModes, EVENTS, TABLE_TYPES} from 'Core/Constant'
import {P} from 'Core/Common/Promise';
import {TranslationManager} from "Core/Components/Translation/TranslationManager";

import {BaseControl} from 'Core/Controls/BaseControl/BaseControl'
import {IControl} from 'Core/Controls/IControl';
import {IControlParam, IScreen} from 'Core/Screens/IScreen'

import Config from 'Core/Controls/StepPage/config.json';
import ViewTemplate from 'Core/Controls/StepPage/Templates/View.html'
import HelpViewTemplate from 'Core/Controls/StepPage/Templates/HelpView.html'
import DesignTemplate from 'Core/Controls/StepPage/Templates/Design.html'
import type { ProcessCardPage } from '../../Screens/ProcessCardPage/ProcessCardPage';
import { BlockUI } from '../../Common/BlockUi';
import { Notifier } from '../Grid/BaseGrid/Index';
import { StepApi } from '../Step/Stores/StepApi';
import {LinkRecordsToStepPage} from 'Core/Controls/StepPage/Models/LinkRecordsToStepPage';
import {LOCK_EVENTS, LockManager} from "Core/Components/Locker/LockManager";
import NewStepScreen from 'Core/Controls/StepPage/NewStepScreen.vue';
import { FormDesignerStore } from 'Core/Controls/FormDesigner/Stores/FormDesignerStore';
import { ISelectorOption, SelectDialog } from 'Core/Components/Dialogs/SelectDialog/SelectDialog';
import { EntitiesStore } from 'Core/Screens/DesignScreen/ControlEditor/Stores/EntitiesStore';
import { EntityTypes } from 'Core/Controls/Grid/BaseGrid/Enums/EntityTypes';
import { CreateNewFormRequestModel } from 'Core/Controls/FormDesigner/Models/CreateNewFormRequestModel';
import { TableStore } from 'Core/Common/Stores/TableStore';
import { EntityTypesStore } from 'Core/Screens/TypeScreen/Stores/EntityTypesStore';

ko.templates['Core/Controls/StepPage/Templates/Design'] = DesignTemplate;
ko.templates['Core/Controls/StepPage/Templates/View'] = ViewTemplate;
ko.templates['Core/Controls/StepPage/Templates/HelpView'] = HelpViewTemplate;
ko.templates['Core/Controls/StepPage/Templates/Edit'] = ViewTemplate;

export class StepPage extends BaseControl {
	
	private _screen: KnockoutObservable<ProcessCardPage>;
	StepRecordId: number;
	StepEntityId: number;
	StepEntityName: string;
	IsNewRecord: boolean;
	private _index: number;
	protected _process: KnockoutObservable<boolean>;
	protected _wait: KnockoutObservable<boolean>;
	protected _finish: KnockoutObservable<boolean>;
	private _transactionId: string;
	private _linksRecords: LinkRecordsToStepPage[];
	private _hasScreen: KnockoutComputed<boolean>;

	constructor(params: IControlParam) {
		super(params, Config);
		this.StepRecordId = 0;
		this._screen = ko.observable(null);
		this._index = null;
		this._process = ko.observable(null);
		this._wait = ko.observable(null);
		this._finish = ko.observable(null);
		this._linksRecords = [];

		this._hasScreen = ko.computed(() => {
			return this._model().ScreenId && this._model().ScreenId != 0
		});

		this.Init();

		this.GetTemplateName = ko.computed(() => {
			var template = RenderModes[this._renderMode()];
			var templateName = `Core/Controls/StepPage/Templates/${template}`;
			return templateName;
		});

	}

	get IsLinked(): boolean{
		return this.GeneralProperties.GetPropertyValue('Linked') == true;
	}

	ApplyProperties() {	}

	private Init(): void {
		this.ApplyProperties();
		this._isActive = ko.observable(false);
		this.AddEvent(EVENTS.ON_TAB_CLICK);
	}

	LoadRecord({entityId, recordId, subjectRecordId, transactionId}: {entityId: number, recordId: number, subjectRecordId, transactionId: string}){		
		this._transactionId = transactionId;
		if(this.StepRecordId == 0){
			BlockUI.Block();
			StepApi.GetStepRecord({PreviousStepEntityId: entityId, PreviousStepRecordId: recordId, StepScreenId: this.ScreenId })
			.always(()=>{
				BlockUI.Unblock();
			})
			.then((record)=>{

				if(!this.IsLinked && record.EntityId == this.Screen.GetEntityId()){
					this.StepRecordId = subjectRecordId;
				}else{
					this.StepRecordId = record.RecordId ? record.RecordId : 0;
				}
				
				this.StepEntityId = record.EntityId;
				this.StepEntityName = record.EntityName;

				this.LoadScreen(this._transactionId);
			});	
		}else{
			this.LoadScreen(this._transactionId);
		}
	}

	async LoadScreen(transactionId: string){
		this._transactionId = transactionId;
		BlockUI.Block();

		let screenManager = (await import('Core/ScreenManager/ScreenManager')).ScreenManager;
		this.IsNewRecord = this.StepRecordId == 0;

		if(!this.IsNewRecord){
			await LockManager.Instance.TryLock(this.StepEntityId, this.StepRecordId).fail(()=>{
				BlockUI.Unblock();
			});

			LockManager.Instance.On(LOCK_EVENTS.RELEASED, this, (eventArgs: any) => {
				if (eventArgs.data.TableId === this.StepEntityId && eventArgs.data.RecordId === this.StepRecordId) {
					this.Screen.Close();
				}
			});
		}

		let screen = (await screenManager.GetScreenById({ ScreenId: this._model().ScreenId, RecordId: this.StepRecordId }));
		if(screen){
			this._screen(screen as ProcessCardPage);
			this._screen().TransactionId = this._transactionId;

			this._screen().On('RECORD_LINKED_TO_STEP_PAGE', this, (eventArgs) => {
				this.AddLinkRecord(eventArgs.data.EntityId, eventArgs.data.RecordId);
			});
		}
		BlockUI.Unblock();
	}

	Save(){
		let deferredResult = P.defer<any>();
		if(this._screen()){
			this._screen().Save(true, false).then((result)=>{
				this.StepRecordId = result.recordId;
				deferredResult.resolve(null);
			});
		}else{
			deferredResult.resolve(null);
		}

		return deferredResult.promise();
	}

	get IsActiveTabPage(): boolean {
		return this._isActive();
	}

	SetValue(value: any): void {}

	Click(): void {
		if (this._help.IsHelpButtonPressed()) {
			this._help.ShowControlHelp(this);
		} else {
			this.Trigger(EVENTS.ON_TAB_CLICK);
		}
	}

	AfterRender(el: Array<HTMLElement>) {
		super.AfterRender(el);
	}

    private GetName(): string {
        var translationList = this._model().NameTranslations;
        let currentLang = TranslationManager.Instance.GetCurrentLanguage();
        let currentLangItem = _.find(translationList, (item) => {
            return currentLang.Id === item.Language.K_Language;
        });
        if (currentLangItem) {
            this._getCurrentName = currentLangItem.Translation;
        }

        if (this._getCurrentName) {
            return this._getCurrentName;
        } else {
            return this._model().Name;
        }
    }

	get Title(): string {
		return this.GetName();
	}

	static GetDefaultName() {
		return 'New step';
	}

	AddSubControl(control: IControl) {
		this._subControls.push(control);
	}

	SelectRecord({ recordId, transactionId }: { recordId: number, transactionId: string }){
		if(this.Screen.GetEntityId() != this._screen().GetEntityId()){
			Notifier.Failed(`There is no process card page with ${this.Screen.GetEntityName()}`);
			return;
		}
		this.StepRecordId = recordId;
		this.LoadScreen(transactionId);
	}

	get EntityId(): number{
		return this.StepEntityId;
	}

	get EntityName(): string{
		return this.StepEntityName
	}

	get ScreenId(): number{
		return this._model().ScreenId;
	}

	get Index(): number {
		return this._index;
	}
	set Index(index: number) {
		this._index = index;
	}

	get Process(): boolean {
		return this._process();
	}
	set Process(process: boolean) {
		this._process(process);
	}

	get Wait(): boolean {
		return this._wait();
	}
	set Wait(wait: boolean) {
		this._wait(wait);
	}

	get Finish(): boolean {
		return this._finish();
	}
	set Finish(finish: boolean) {
		this._finish(finish);
	}

	get LinksRecords(): LinkRecordsToStepPage[] {
		return this._linksRecords;
	}

	AddLinkRecord(entityId: number, recordId: number) {
		if (_.any(this._linksRecords, linkRecords => linkRecords.EntityId == entityId)) {
			const linkRecordsModel = _.find(this._linksRecords, linkRecords => linkRecords.EntityId === entityId);
			linkRecordsModel.RecordIds.push(recordId);
			return;
		}

		this._linksRecords.push({
			EntityId: entityId,
			RecordIds: [recordId]
		});
	}

	ClearLinksRecords() {
		this._linksRecords = [];
	}
	
	async EditScreen(){
		const formDesignerPageType = (await import('Pages/FormDesignerPage')).FormDesignerPage;
		var formDesignerPage = new formDesignerPageType();
    	formDesignerPage.ShowInModal();
    	formDesignerPage.SetScreenId(this._model().ScreenId);
	}

	AddScreen(){
		this.ShowEntitySelector();
	}

	private async ShowEntitySelector() {
		BlockUI.Block();

		let types = await EntityTypesStore.GetTypes({
				EntityId: 0,
				ParentTypeId: 0,
				WithRoot: true,
				OnlyEnabled: false,
				EntityName: 'CD_FORMS'
		});

		let processCardPageType = types.TableTypes.find(type=>type.Name == 'ProcessCardPage');

		EntitiesStore.Get({
			EntityId: this.Screen.GetEntityId(),
			TableTypeId: 0
		}).always(()=>{
			BlockUI.Unblock();
		})
		.then(data => {
			const options: Array<ISelectorOption<number>> = data
			.filter(entity=>entity.TypeName == TABLE_TYPES.Entity)
			.map((entity): ISelectorOption<number> => {
				return {Text: entity.EntityName, Value: entity.EntityId};
			});
	
			const selectEntityDialog = new SelectDialog({
				Label: 'Entity:',
				Options: options,
				SelectedOption: options[1]
			});
	
			selectEntityDialog.On('Save',
				this,
				(eventArgs) => {
					const selectedOption: ISelectorOption<number> = eventArgs.data;
					const selectedEntityId = selectedOption.Value;
					const tableTypeId = 0;
					this.CreateNewForm(selectedEntityId, processCardPageType.Id, tableTypeId, 0, null);
				});
	
			selectEntityDialog.Show();
		});
	}

	 private CreateNewForm(entityId: number, typeId: number, tableTypeId: number, exampleRecordId: number, fieldCollectionId: number) {
        BlockUI.Block();
        FormDesignerStore.CreateNewForm(new CreateNewFormRequestModel(entityId, typeId, tableTypeId, fieldCollectionId))
            .then(async screenModel => {
				this._model().ScreenId = screenModel.FormId;
				this._model.valueHasMutated();
               	const formDesignerPageType = (await import('Pages/FormDesignerPage')).FormDesignerPage;
				var formDesignerPage = new formDesignerPageType();
    			formDesignerPage.ShowInModal();
    			formDesignerPage.SetScreenId(this._model().ScreenId);
            })
            .fail((err) => new Notifier($(this._el)).Failed(err.message))
            .always(() => {
                BlockUI.Unblock();
            });
    }
}